// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"97e7f9cc","787":"c1112931"}[chunkId] + ".chunk.js";
};